import { useTranslation } from 'react-i18next';
import { useMenuManager } from '../utils/manager/menu-manager';
import { useAnalytics } from '../utils/setup/analytics-setup';
import { useStorage } from './use-storage';

function useOpenWhatsApp() {
  const { analyticsHelpEvent } = useAnalytics();
  const { getWhatsAppLink } = useMenuManager();
  const { user } = useStorage();
  const { t } = useTranslation();

  return (message) => {
    const msg = message?.trim()?.length > 0 ? message?.trim() : '';
    const hello =
      user?.name?.trim()?.length > 0
        ? t('whatsapp.hello', { name: user?.name.trim() })
        : '';
    const full = (hello + msg).trim();
    const text = full.length > 0 ? `?text=${encodeURI(full)}` : '';

    analyticsHelpEvent('whatsapp icon click');
    // eslint-disable-next-line no-undef
    window.location.href = getWhatsAppLink(text);
  };
}

export { useOpenWhatsApp };
